import React from 'react';
import { LogisticsObjectDetailPage } from '@/components/common/LogisticsObjectDetailPage';

const PieceDetailPage: React.FC = () => {
  return (
    <LogisticsObjectDetailPage
      config={{
        logisticsObjectType: 'piece',
        routeParamKey: 'pieceId',
        pageTitle: 'Piece Details',
        backRoute: '/pieces',
        backLabel: 'Back to Pieces',
        tabIdPrefix: 'piece',
        tabsAriaLabel: 'piece detail tabs',
        missingIdMessage: 'No piece ID provided in the URL.',
        noDataMessage: 'No piece data available. The piece might not exist or you may not have permission to view it.',
      }}
    />
  );
};

export default PieceDetailPage;
